module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/192.158a98b7.png";